import vars from "../helpers";

const init = () => {
    const $leadership = vars.$document.find('.contacts__peoples');
    const $slider = document.querySelector('.contacts__peoples');
    if ($leadership.length && vars.isMobile()) {
        new Swiper($slider, {

            initialSlide: 0,
            slidesPerView: "auto",
            spaceBetween: 30,
            // centeredSlides: true,
            loop: true,
            slideToClickedSlide: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },

            breakpoints: {
                // when window width is >= 320px
                1: {
                    slidesPerView: 1,
                    spaceBetween: 0
                },
                1025: {
                    initialSlide: 0,
                    slidesPerView: "auto",
                    spaceBetween: 30,
                }
            }
        });
    }
};

export default {
    init,
}
